module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-7a9be4d0!./packages/dof-collapse-item/diablo.css
// module id = 521
// module chunks = 0 1